import { render, staticRenderFns } from "./ProjectGanttChart.vue?vue&type=template&id=69806b34&"
import script from "./ProjectGanttChart.vue?vue&type=script&lang=js&"
export * from "./ProjectGanttChart.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGanttChart.vue?vue&type=style&index=0&id=69806b34&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69806b34')) {
      api.createRecord('69806b34', component.options)
    } else {
      api.reload('69806b34', component.options)
    }
    module.hot.accept("./ProjectGanttChart.vue?vue&type=template&id=69806b34&", function () {
      api.rerender('69806b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectmanagement/ProjectGanttChart.vue"
export default component.exports